module.exports = __webpack_public_path__ + "img/partners_1.ba3c1299.png";